import Tas from "./Components/tas/components/Tas";

export default function App() {
  return(
      <Tas/>
  )
}
